export default function openInNewWindow(path, query={}) {
    let routeData = this.$router.resolve({
        path: path,
        query: query,
    });
    window.open(routeData.href, '_blank');
}
